import React from 'react';
import PropTypes from 'prop-types';
import { exceedsMaxLength, isOnlySpaceString } from '../../../../common/helpers/common.helpers';
import { EMPTY_STRING, ERROR_CLASS_NAME, FILE_NAME_MAX_LENGHT } from '../../../../constants/constants';
import './text-input-name.style.scss';

/**
 * Class representing text input name.
 * @extends React.Component
 * */
class TextInputName extends React.Component {

  state = {
    initialValue: EMPTY_STRING,
    lastBubbledUpValue: EMPTY_STRING,
    valid: true,
    value: EMPTY_STRING
  };

  /**
   * Sets initial value.
   * */
  componentDidMount() {
    const { value } = this.props;
    this.setState({
      initialValue: value,
      value
    });
  }


  /**
   * Updates state if props changed
   * @param {object} nextProps - The next props.
   * */
  componentWillReceiveProps(nextProps) {
    const { value } = this.props;
    const { lastBubbledUpValue } = this.state;

    if (value === lastBubbledUpValue && value !== nextProps.value) {
      this.setState({
        initialValue: nextProps.value,
        value: nextProps.value
      });
    }
  }


  /**
   * Selects all text if user clicks in input.
   * @param {object} event - The event value.
   * */
  onFocus = (event) => {
    const { target } = event;
    // event.target.select(); not working on mobile browsers
    target.setSelectionRange(0, 9999);
  }

  /**
   * Update valid state when input blur event is triggered
   * @param {object} event - The event value.
   * */
  onBlur = (event) => {
    const { value } = event.target;
    this.setState({
      valid: (value !== EMPTY_STRING)
    });
  }


  /**
   * Stores current value in state and triggers the change event up after a debounced amount of time.
   * @param {object} event - The event value.
   * */
  onChange = (event) => {
    const { value } = event.target;
    this.setState({ value });

    const { initialValue } = this.state;
    const { onValueChange } = this.props;

    if (exceedsMaxLength(value, FILE_NAME_MAX_LENGHT)) {
      return;
    }
    if (value && value !== initialValue && !isOnlySpaceString(value)) {
      this.setState({ lastBubbledUpValue: value });
      onValueChange(value);
    }
  };

  /**
  * Returns error class or empty string if all is valid
  * Checks injected props error plus local input valid state
  * @return {string} - The error class.
  * */
  getErrorClass = () => {
    const { isError } = this.props;
    const { valid } = this.state;

    return (isError || !valid ? ERROR_CLASS_NAME : EMPTY_STRING);
  }


  render() {
    const {
      inputClass,
      placeholder,
      type
    } = this.props;
    const {
      valid,
      value
    } = this.state;

    return (
      <div className="in-edit-mode">
        <div className={`input-wrapper ${this.getErrorClass()}`}>
          <input
            className={`form-control ${inputClass}`}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            placeholder={placeholder}
            required
            type={type}
            value={value}
          />
          {!valid && (
            <span className="error-text">Title is required</span>
          )}

        </div>
      </div>
    );
  }

}

export default TextInputName;

TextInputName.propTypes = {
  inputClass: PropTypes.string,
  isError: PropTypes.bool,
  onValueChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.string
};

TextInputName.defaultProps = {
  inputClass: EMPTY_STRING,
  isError: false,
  placeholder: EMPTY_STRING,
  value: EMPTY_STRING
};



// WEBPACK FOOTER //
// ./src/messages/dashboard/file-details/text-input-name/text-input-name.component.js